module.exports = __webpack_public_path__ + "static/img/5.48d694e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homepage/bcimg/5.jpg
// module id = bbhM
// module chunks = 1